import dayjs from "dayjs";
import PdfHeader from "../../../../components/pafHeader";

const SupportReport = ({ data, date, reportType = "LAWYERS", status, selectedMonth, selectedMonthString }) => {
    return <div className="print-page">
        <div className="report-container" style={{ padding: 0, margin: 0 }}>
            <PdfHeader pdfName={reportType === "LAWYERS" ? "Advocate Support Report" : reportType === "CUSTOMERS" ? "Customer Support Report" : "Support Report"} />
            <div className="total-details flexible">
                {
                    (date?.fromDate && date?.toDate) && <>
                        <div>
                            <h4 className="information-title">Date</h4>
                            <p style={{ margin: 0, padding: "10px 0px" }}>{date?.fromDate && date?.toDate ? `${dayjs(date?.fromDate).format("DD-MM-YYYY")} to ${dayjs(date?.toDate).format("DD-MM-YYYY")}` : "-"}</p>
                        </div>
                    </>
                }
                {
                    selectedMonth && <>
                        <div>
                            <h4 className="information-title">Month</h4>
                            <p style={{ margin: 0, padding: "10px 0px" }}>{dayjs(selectedMonth).format("MMMM YYYY")}</p>
                        </div>
                    </>
                }
                <div>
                    <h3 className="information-title">{reportType === "LAWYERS" ? "Advocate" : "Customer"}</h3>
                    <h2 className="information-detail">{data?.length}</h2>
                </div>
            </div>
            <table className="report-table">
                <thead>
                    <tr>
                        <th colSpan={1}>SNo</th>
                        <th colSpan={2}>Date</th>
                        <th colSpan={3}>{reportType === "LAWYERS" ? "Advocate Name/ ID" : "Customer Name/ ID"}</th>
                        <th colSpan={6}>Support Description</th>
                        {status === "COMPLETED" && <th colSpan={4}>Action Item</th>}
                        <th colSpan={3}>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((detail, index) => (
                        <tr key={detail?.id || index}>
                            <td colSpan={1}>{index + 1}</td>
                            <td colSpan={2}>{detail?.supportDate ? dayjs(detail?.supportDate).format("DD-MM-YYYY") : "Nil"}</td>
                            <td colSpan={3}>
                                <span style={{ fontWeight: '600' }}>{detail?.raisedByName || "Nil"}</span>
                                <br />
                                <small>{detail?.raisedByNo || "Nil"}</small>
                            </td>
                            <td colSpan={6}>{detail?.description || "Nil"}</td>
                            {status === "COMPLETED" && <td colSpan={4}>{detail?.actionItem || "Nil"}</td>}
                            <td colSpan={3}>
                                {
                                    detail?.complaintStatus === "COMPLETED" ? <div className="success-status">
                                        <p className="custom-header">Completed</p>
                                    </div> : detail?.complaintStatus === "PENDING" ? <div className="pending-status">
                                        <p className="custom-header">Pending</p>
                                    </div> : <div style={{ textAlign: "center" }}>Nil</div>
                                }
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>;
};

export default SupportReport;
